import { uuid } from 'vue-uuid';

export default {
  generate() {
    return uuid.v4();
  },
};
